import styled from 'styled-components';
import { Container, ContainerProps } from '../layout';

export const PreviewContainer = styled(Container)`
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.borderRadii.large};
  display: flex;
  height: 72px;
  justify-content: flex-start;
  padding: 0 24px;
  && * {
    flex-shrink: 0;
  }
`;

export const Dropzone = styled(PreviewContainer)`
  cursor: pointer;
  margin-top: 16px;
  border: ${props => `1px dashed ${props.theme.colors.background.controls}`};
  background-color: unset;
  justify-content: flex-start;
`;

export const DocumentContainer = styled(Container)<
  ContainerProps & { backgroundImage: string }
>`
  background-image: url(${props => props.backgroundImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: ${props => props.theme.borderRadii.small};
  display: inline;
  height: 40px;
  overflow: hidden;
  width: 40px;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
`;
